(ns frontend.ui.component.lp-portal.voima-components.section.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

(defn section
  []
  {:width "100%"})

(defn header
  []
  (merge {:padding       "8px 0"
          :border-bottom (space-join ["1px solid" (theme/color [:lp-report :section :border])])
          :font-size     "32px"
          :font-weight   "bold"
          :color         (theme/color [:lp-report :section :default])}
         (when (= (theme/get-theme) :theme.lp-portal/lifeline)
           {:font-family "SuperiorTitleBlack"})))

(defn portfolio-header
  []
  {:padding     "8px 0"
   :border-top  (space-join ["1px solid" (theme/color [:lp-report :section :border])])
   :font-size   "32px"
   :font-weight "bold"
   :margin-top  "40px"
   :color       (theme/color [:lp-report :section :default])
  })

(defn content
  []
  {:margin-top "8px"})

(defn header-alternative
  []
  {:padding         "8px 0"
   :font-size       "32px"
   :font-weight     "bold"
   :color           (theme/color [:lp-report :section :default])
   :display         "flex"
   :justify-content "center"
   :border          "none"})

(defn holding-header
  []
  (merge {:padding         "0px 0"
          :font-size       "32px"
          :font-weight     "bold"
          :color           (theme/color [:lp-report :section :default])
          :display         "flex"
          :justify-content "center"
          :border          "none"
          :white-space     "nowrap"}
         (when (= (theme/get-theme) :theme.lp-portal/lifeline)
           {:font-family "SuperiorTitleBlack"})))

(defn section-wrapper
  []
  {:width            "100%"
   :background-color "white"
   :padding          "4px 16px 16px 16px"
   :border-radius    "16px"})

(defn section-wrapper-alternative
  []
  {:width            "100%"
   :background-color "white"
   :padding          "16px 16px 16px 16px"
   :border-radius    "16px"})

(defn section-wrapper-logo
  []
  {:width "15%"})
